import { ConfigProvider } from 'antd';
import ruRU from 'antd/locale/ru_RU';
import { agentBrokerTheme } from '@shared/antd-theme';
import { BuildInfo } from '@shared/BuildInfo';
import MortgageWelcome from './MortgageWelcome';

interface AppProps {
    userId: string;
    csrf: string;
}

export default function App({ userId, csrf }: AppProps) {
    return (
        <ConfigProvider locale={ruRU} theme={agentBrokerTheme}>
            <MortgageWelcome userId={userId} csrf={csrf} />
            <BuildInfo />
        </ConfigProvider>
    );
}
